import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        apiError: {
            color: colors[mode].errorText,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            marginTop: '16px'
        },
        backButton: {
            '&.MuiButton-root': {
                border: '1px solid #003168',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: '64px'
            }
        },
        buttonContainer: {
            display: 'flex',
            gap: '2%',
            justifyContent: 'flex-end',
            width: '100%'
        },
        content: {
            minHeight: '225px',
            padding: '25px 28px'
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: '345px'
        },
        countryCodeField: {
            '& .MuiInput-underline.Mui-focused:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:before': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
            },
            '& .MuiInputLabel-root': {
                color: `${colors[mode].cardDescription} !important`,
                fontFamily: 'Roboto',
                fontSize: '1rem',
                fontWeight: 400,
                letterSpacing: '0.15px',
                verticalAlign: 'middle'
            },
            '& .MuiSelect-icon': {
                left: '0',
                position: 'absolute',
                right: 'auto'
            },
            '& .MuiSelect-select': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 400,
                letterSpacing: '0.15px',
                lineHeight: '20px',
                paddingLeft: '24px'
            },
            minWidth: '123px',
            width: '123px',
            [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
                width: '100%'
            }
        },
        customLoader: {
            paddingTop: '18%',
            [theme.breakpoints.down('sm')]: {
                paddingTop: '32%',
            }
        },
        extensionField: {
            '& .MuiInput-underline.Mui-focused:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:before': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
            },
            '& .MuiInputLabel-root': {
                color: `${colors[mode].cardDescription} !important`,
                fontFamily: 'Roboto',
                fontSize: '1rem',
                fontWeight: 400,
                letterSpacing: '0.15px',
                verticalAlign: 'middle',
                whiteSpace: 'nowrap'
            },
            '& input': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 400,
                letterSpacing: '0.15px',
                lineHeight: '20px'
            },
            minWidth: '119px',
            width: '119px',
            [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
                width: '100%'
            }
        },
        fieldsRow: {
            alignItems: 'flex-start',
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '13px',
            marginTop: '32px',
            overflow: 'hidden',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'flex-start',
                flexDirection: 'column',
                gap: '16px',
                padding: 0
            }
        },
        helpText: {
            fontStyle: 'italic',
            padding: '18px 24px',
            [theme.breakpoints.down('md')]: {
                padding: '7px 24px'
            },
            [theme.breakpoints.down('sm')]: {
                padding: '0px 24px 0px 24px'
            }
        },
        nextButton: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                color: '#003168',
                height: '32px',
                padding: '8px 16px',
                width: 'auto'
            }
        },
        nextButtonDisabled: {
            '&.MuiButton-root': {
                opacity: '50%'
            }
        },
        phoneNumberField: {
            '& .MuiFormHelperText-root': {
                color: colors[mode].errorText,
                fontFamily: 'Roboto',
                fontSize: '12px',
                marginLeft: 0
            },
            '& .MuiInput-underline.Mui-focused:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:before': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInputLabel-root': {
                color: `${colors[mode].cardDescription} !important`,
                fontFamily: 'Roboto',
                fontSize: '1rem',
                fontWeight: 400,
                letterSpacing: '0.15px',
                verticalAlign: 'middle'
            },
            '& input': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 400,
                letterSpacing: '0.15px',
                lineHeight: '20px'
            },
            minWidth: '178px',
            width: '178px',
            [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
                width: '100%'
            }
        },
        recoveryTypeField: {
            '& .MuiInput-underline.Mui-focused:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:after': {
                borderBottom: `1px solid ${colors[mode].borderBottom}`
            },
            '& .MuiInput-underline:before': {
                borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
            },
            '& .MuiInputLabel-root': {
                color: `${colors[mode].cardDescription} !important`,
                fontFamily: 'Roboto',
                fontSize: '1rem',
                fontWeight: 400,
                letterSpacing: '0.15px',
                verticalAlign: 'middle'
            },
            '& .MuiSelect-icon': {
                left: '0',
                position: 'absolute',
                right: 'auto'
            },
            '& .MuiSelect-select': {
                color: colors[mode].cardDescription,
                fontFamily: 'Roboto',
                fontSize: '14px',
                fontWeight: 400,
                letterSpacing: '0.15px',
                lineHeight: '20px',
                paddingLeft: '24px'
            },
            minWidth: '123px',
            width: '123px',
            [theme.breakpoints.down('sm')]: {
                minWidth: '100%',
                width: '100%'
            }
        },
        subTitle: {
            color: colors[mode].secondaryText,
            fontFamily: 'Roboto',
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingRight: '3%'
        }
    }
}
